import Button from '@/components/Buttons/Button';
import ShareView from '@/images/ShareView.svg';
import styled from '@emotion/styled';

// todo - should be replaced to new white button
const StyledButton = styled(Button)<{ white?: boolean }>`
    background-color: ${({ theme, white }) => white && theme.colors.white};
    color: ${({ theme, white }) => white && theme.colors.black[800]};
    border-color: ${({ theme, white }) => white && theme.colors.black[300]};

    :hover {
        border-color: ${({ theme, white }) => white && theme.colors.black[300]} !important;
    }
`;

interface Props {
    onClick: (e: any) => void;
    white?: boolean;
}

export const ViewAsGuestButton = ({ onClick, white }: Props) => {
    return (
        <StyledButton color="secondary" variant="outlined" startIcon={<img src={ShareView} />} onClick={onClick} white={white}>
            View as guest
        </StyledButton>
    );
};
